import { createSlice } from "@reduxjs/toolkit";

const psikotesNavbarSlice = createSlice({
  name: "psikotesNavbar",
  initialState: {
    page: null,
    start: false,
    timer: null,
  },
  reducers: {
    setNavbarConfig: (state, action) => {
      state.page = action.payload.page;
      state.start = action.payload.start;
      state.timer = action.payload.timer;
    },
    resetNavbar: (state) => {
      state.page = null;
      state.start = false;
      state.timer = null;
    },
  },
});

export const { setNavbarConfig, resetNavbar } = psikotesNavbarSlice.actions;

export default psikotesNavbarSlice.reducer;
